import { Modal } from 'react-bootstrap-v5';
import { useIntl } from 'react-intl';
import { Formik, Form } from 'formik';
import { IntlShape } from 'react-intl';
import * as Yup from 'yup';
import { OrderViewModel } from '../models/OrderViewModel';
import { CustomSelect } from '../../../components/CustomSelect';
import { ActionsComponent } from '../../../components/ActionsComponent';

const warehouseInventoryActionOptions = [
  { value: 'return', label: 'Return inventory' },
  { value: 'notReturn', label: 'Do not return inventory' },
];

export const returnOrderSchema = (intl: IntlShape) =>
  Yup.object().shape({
    warehouseInventoryAction: Yup.string().required(
      intl.formatMessage({ id: 'VALIDATION.REQUIRED_FIELD' })
    ),
  });

interface ReturnFormValues {
  warehouseInventoryAction?: string;
}
const initialValues: ReturnFormValues = { warehouseInventoryAction: 'return' };

interface Props {
  returnOrder: (params: any) => void;
  show: boolean;
  order: OrderViewModel;
  onHide: () => void;
}

export function ReturnOrderModal({ returnOrder, show, order, onHide }: Props) {
  const intl = useIntl();
  const save = (values: ReturnFormValues) => {
    returnOrder({ ...values, order });
  };

  return (
    <Modal show={show} onHide={onHide} backdrop='static' keyboard={false}>
      <Formik
        initialValues={initialValues}
        validationSchema={returnOrderSchema(intl)}
        onSubmit={(values, actions) => {
          save(values);
          actions.setSubmitting(false);
        }}
      >
        <Form>
          <Modal.Body className='mt-1 px-6 py-6 position-relative z-index-1'>
            <div className='d-flex align-items-center mb-4'>
              <i className={`las la-exclamation-circle fs-5x text-warning`}></i>
              <div className='flex-grow-3 ms-4'>
                <div className='fw-bold text-gray-700 fs-6'>
                  Are you sure you want to return this order?
                </div>
                <div className='fw-bold text-gray-1000 fs-6'>
                  This operation cannot be undone.
                </div>
              </div>
            </div>
            {order.status === 'Shipped' && (
              <div>
                <CustomSelect
                  isRequired={true}
                  label='Warehouse inventory action'
                  id='warehouseInventoryAction'
                  options={warehouseInventoryActionOptions}
                  name='warehouseInventoryAction'
                  isDisabled={false}
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className=' border-0'>
            <ActionsComponent
              labelSubmit='Yes'
              labelDiscard='No'
              showCancelButton={true}
              onCancel={onHide}
            />
          </Modal.Footer>
        </Form>
      </Formik>
    </Modal>
  );
}
